import styled from "styled-components";

function TextHome3(){
    return(
        <TextSpam>
            <h2>Juntos com você</h2>
            Entendemos que optar por jogar em um servidor significa investir um <b>precioso tempo</b> em prol de um diversão, e nada pode ser mais decepcionante do que jogar em servidores <b>sem compromisso</b>, com resets constantes, com má administração. <br/><br/>

            <b>Aqui nos trabalhamos Sério e trapaça não tem vez!</b><br/><br/>

            Contamos com um rigoroso regulamento ético punitivo, softwares de segurança, além da sua ajuda através de denuncias,
            nós garantimos a harmonia da comunidade pra você.<br/><br/>
        </TextSpam >
    );
};

const TextSpam = styled.span`
`;

export default TextHome3;